<template>
  <div class="modal-card" style="width: auto">
    <form method="post" @submit.prevent="onSend" novalidate>
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">
          匯出月報表
        </p>
      </header>

      <section class="modal-card-body">
        <form-wrapper :validator="$v.form">
          <form-group name="month" label="年度月份" label-position="on-border">
            <b-datepicker
              v-model="date"
              type="month"
              :min-date="minDate"
              :max-date="maxDate"
              placeholder="請選擇年度及月份"
              icon="calendar-today"
              inline
              trap-focus
              required
              @input="onSelectedMonth"
            >
            </b-datepicker>
          </form-group>
        </form-wrapper>
      </section>

      <footer class="modal-card-foot">
        <b-button
          :loading="sending"
          class="is-fullwidth"
          @click="$parent.close()"
        >
          {{ $t('attributes.cancel') }}
        </b-button>
        <b-button
          :loading="sending"
          type="is-primary"
          class="is-fullwidth"
          native-type="submit"
        >
          匯出
        </b-button>
      </footer>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ExportMonthForm',

  props: {
    sending: {
      type: Boolean
    }
  },
  data() {
    const today = this.$dayjs().toDate()
    const month = this.$dayjs()
      .subtract(1, 'month')
      .toDate()

    return {
      minDate: this.$dayjs('2021-01-01').toDate(),
      maxDate: today,
      date: month,

      form: {
        date: this.formatMonth(month)
      }
    }
  },
  validations() {
    return {
      form: {
        date: { required }
      }
    }
  },
  methods: {
    onSelectedMonth(date) {
      this.form.date = this.formatMonth(date)
    },

    onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form.date)
    }
  }
}
</script>
